// extracted by mini-css-extract-plugin
export default {"info-buttons":"headerContent_info-buttons__1D8ju","info-buttons-without-ribbon":"headerContent_info-buttons-without-ribbon__ykqFb"};